<template>
  <div
    class="content-slide-ppt-wrp"
    :class="{'hidden': isWhiteLabel}"
  >
    <div class="toolbar-container bg-white-100 flex rounded-lg py-1.5">
      <div class="improve-container" v-if="canUseAIImproveDirectly">
        <ImproveWritingDropDown class="h-full flex items-center" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Util from '@/util'
import ImproveWritingDropDown from '@/components-v2/presentation-editor/freestyle/ImproveWritingDropDown.vue'

export default {
  components: {
    ImproveWritingDropDown,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    slideType: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('zoomApp', ['isZoomReady']),
    ...mapGetters('aiAutoImproveSlideContent', ['canUseAIImproveDirectly']),
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    isWhiteLabel() {
      return Util.checkWhiteLabelDomain()
    },
  },
}
</script>

<style lang="scss" scoped>
.content-slide-ppt-wrp {
  display: flex;
  @apply items-center justify-center rounded-lg my-3;
  &.hidden {
    margin-top: 60px;
  }
}
.toolbar-container {
  height: auto;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.improve-container {
  padding-right: 12px;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
